import imageClipper from './imageClipper.vue';

export default {
    install(Vue) {
        Vue.component(imageClipper.name, imageClipper);
    }
}